/** TODO temporary. will be refactored */

import { Injectable, Injector } from '@angular/core';
import { ActivationStart, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@cmps/ng-bootstrap';
import { from, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { SecurityScope } from '../auth/auth.model';

import { Options, PopUpService } from './experimental.pop-up';
import { SearchUserContainerComponent } from './search-user.container.component';
import { SearchUserDialogRef } from './search-user.dialog-ref';
import { User } from './user.model';

interface OptionsNgb {
    options?: NgbModalOptions;
    storePathPrefix?: string;
    userId?: number;
    scope?: SecurityScope;
    close?: (user?: User) => void;
}

interface OptionsPopUp {
    options?: Options;
    storePathPrefix?: string;
    userId?: number;
    scope?: SecurityScope;
    close?: (user?: User) => void;
}

@Injectable()
export class SearchUserDialog {
    private readonly _refs: SearchUserDialogRef[];

    constructor(
        private readonly _injector: Injector,
        private readonly _router: Router,
        private readonly _modalService: NgbModal,
        private readonly _popUpService: PopUpService,
    ) {
        this._refs = [];

        this._router.events
            .pipe(
                filter((evt) => evt instanceof ActivationStart),
                tap(() => this.closeAll()),
            )
            .subscribe();
    }

    openUsingNgbModal(options: OptionsNgb): SearchUserDialogRef {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const opts = options || ({} as OptionsNgb);
        const mOpts = opts.options || {};

        const retRef = new SearchUserDialogRef();
        const injector = Injector.create({
            providers: [{ provide: SearchUserDialogRef, useValue: retRef }],
            parent: mOpts.injector || this._injector,
        });

        const ref = this._modalService.open(SearchUserContainerComponent, {
            centered: true,
            size: 'lg',
            windowClass: 'cmps-search-user-modal',
            ...mOpts,
            injector,
        });
        retRef._refNgb = ref;
        this._refs.push(retRef);

        const result = from(ref.result);
        const comp = ref.componentInstance as SearchUserContainerComponent;

        this._setupComponent(opts, result, comp);

        return retRef;
    }

    openUsingPopUp(options: OptionsPopUp): SearchUserDialogRef {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const opts = options || ({} as OptionsPopUp);
        const mOpts = opts.options || { target: () => document.body };

        const retRef = new SearchUserDialogRef();
        const injector = Injector.create({
            providers: [{ provide: SearchUserDialogRef, useValue: retRef }],
            parent: mOpts.injector || this._injector,
        });

        const ref = this._popUpService.show(SearchUserContainerComponent, {
            ...mOpts,
            injector,
        });
        retRef._refPopUp = ref;
        this._refs.push(retRef);

        const result = from(ref.result);
        const comp = ref.componentRef.instance;

        this._setupComponent(opts, result, comp);

        return retRef;
    }

    closeAll(): void {
        this._refs.reverse();
        while (this._refs.length > 0) {
            this._refs.splice(0, 1)[0].close();
        }
    }

    private _setupComponent(
        opts: OptionsNgb | OptionsPopUp,
        result: Observable<User>,
        comp: SearchUserContainerComponent,
    ): void {
        comp.storePathPrefix = opts.storePathPrefix;
        comp.userId = opts.userId;
        comp.scope = opts.scope;

        result
            .pipe(
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                tap((user) => opts.close && opts.close(user)),
            )
            .subscribe({
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                error: () => opts.close && opts.close(),
            });
    }
}
